import {styled} from '@mui/material';

export const IconButton = styled('div')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 3,
  padding: 3,
  fontSize: 14,
  '&:hover': {
    backgroundColor: 'rgb(200, 200, 200, 0.2)',
  },
});

export default IconButton;
